import { render } from "./RuleChangeLogFields.vue?vue&type=template&id=6665022c"
import script from "./RuleChangeLogFields.vue?vue&type=script&lang=js"
export * from "./RuleChangeLogFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleChangeLogFields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6665022c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6665022c', __exports__)) {
    api.reload('6665022c', __exports__)
  }
  
  module.hot.accept("./RuleChangeLogFields.vue?vue&type=template&id=6665022c", () => {
    api.rerender('6665022c', render)
  })

}


export default __exports__